console.log("[up-wb] Custom Web Pixel start");

var ids = {
  ga4: "G-FZQBYYRSLD",
  ads: "AW-1063682578",
  mcc: { tag: "GT-KF8J8JVT", destination: "MC-Q58D10J5PJ" },
  adsConversions: {
    product_added_to_cart: "AW-1063682578/v7PkCPzFyvcaEJKEmvsD",
    product_viewed: "AW-1063682578/bj2ZCILGyvcaEJKEmvsD",
    checkout_started: "AW-1063682578/Xk-fCP_FyvcaEJKEmvsD",
    checkout_completed: "AW-1063682578/051ECNvFyvcaEJKEmvsD",
    checkout_completed_bis: "AW-1063682578/C4bNCNjFyvcaEJKEmvsD", // For Client & Server Side
  },
  uet: "5795858"
};

window.dataLayer = window.dataLayer || [];
function gtag() {
  dataLayer.push(arguments);
}

// monkey-patching to remove wpm trace on auto events
const regexWpm = /\/web-pixels@[a-zA-Z0-9]+\/custom\/web-pixel-[0-9]+@[0-9]+\/sandbox\/modern/;
const originalFetch = window.fetch;
window.fetch = function (...args) {
  let [url, options] = args;
  // console.log(url, options);
  if (decodeURIComponent(url).includes("/web-pixels@")) {
    url = decodeURIComponent(url).replace(regexWpm, "");
  }

  if (url.includes("willemse.user.com") && options && options.method === "POST" && options.body) {
    try {
      const bodyObject = JSON.parse(options.body);
      if (
        bodyObject.url &&
        typeof bodyObject.url === "string" &&
        decodeURIComponent(bodyObject.url).includes("/web-pixels@")
      ) {
        bodyObject.url = decodeURIComponent(bodyObject.url).replace(regexWpm, "");
        options = {
          ...options,
          body: JSON.stringify(bodyObject),
        };
      }
    } catch (e) { }
  }

  return originalFetch.apply(this, [url, options]);
};

// Init initial consent
gtag("consent", "default", {
  ad_user_data: init.customerPrivacy.marketingAllowed ? "granted" : "denied",
  ad_personalization: init.customerPrivacy.marketingAllowed ? "granted" : "denied",
  ad_storage: init.customerPrivacy.marketingAllowed ? "granted" : "denied",
  analytics_storage: init.customerPrivacy.analyticsProcessingAllowed ? "granted" : "denied",
  wait_for_update: 100,
});
// gtag("set", "url_passthrough", true); // Not works in sandbox

// For Bing
window.uetq = window.uetq || [];
window.uetq.push("consent", "default", {
  ad_storage: init.customerPrivacy.marketingAllowed ? "granted" : "denied",
});

// Subscribe to event to update consent
api.customerPrivacy.subscribe("visitorConsentCollected", (event) => {
  gtag("consent", "update", {
    ad_user_data: event.customerPrivacy.marketingAllowed ? "granted" : "denied",
    ad_personalization: event.customerPrivacy.marketingAllowed ? "granted" : "denied",
    ad_storage: event.customerPrivacy.marketingAllowed ? "granted" : "denied",
    analytics_storage: event.customerPrivacy.analyticsProcessingAllowed ? "granted" : "denied",
  });
  window.uetq.push("consent", "update", {
    ad_storage: event.customerPrivacy.marketingAllowed ? "granted" : "denied",
  });
});

gtag("policy", "detect_click_events", () => false);
gtag("policy", "detect_element_visibility_events", () => false);
gtag("policy", "detect_history_change_events", () => false);
gtag("policy", "detect_link_click_events", () => false);
// gtag("policy", "detect_timer_events", () => false);
gtag("policy", "detect_youtube_activity_events", () => false);
gtag("policy", "detect_scroll_events", () => false);
gtag("policy", "detect_form_submit_events", () => false);
gtag("policy", "detect_form_interaction_events", () => false);
gtag("policy", "internal_sw_allowed", () => false);

gtag("js", new Date());

gtag("config", ids.ga4, { send_page_view: false, user_id: init.data?.customer?.id });
gtag("config", ids.ads, { send_page_view: false, user_id: init.data?.customer?.id });
if (ids.mcc?.tag) gtag("config", ids.mcc.tag, { send_page_view: false, user_id: init.data?.customer?.id });
let script = document.createElement("script");
script.src = `https://www.googletagmanager.com/gtag/js?id=${ids.ga4}`;
document.body.appendChild(script);

// prettier-ignore
(function (w, d, t, r, u) { var f, n, i; w[u] = w[u] || [], f = function () { var o = { ti: ids.uet, disableAutoPageView: true }; o.q = w[u], w[u] = new UET(o), w[u].push("pageLoad") }, n = d.createElement(t), n.src = r, n.async = 1, n.onload = n.onreadystatechange = function () { var s = this.readyState; s && s !== "loaded" && s !== "complete" || (f(), n.onload = n.onreadystatechange = null) }, i = d.getElementsByTagName(t)[0], i.parentNode.insertBefore(n, i) })(window, document, "script", "//bat.bing.com/bat.js", "uetq");

// Utils

const filterNullOrEmpty = (obj, limitSubElement = 5) => {
  let filteredObj = {};
  if (limitSubElement <= 0) {
    return obj;
  }
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      let value = obj[key];

      // If value is an object (and not null), recursively filter sub-elements
      if (typeof value === "object" && value !== null && value !== undefined) {
        let filteredSubObject = filterNullOrEmpty(value, limitSubElement - 1);

        // Add the filtered sub-object only if it's not empty
        if (Object.keys(filteredSubObject).length > 0) {
          filteredObj[key] = filteredSubObject;
        }
      } else {
        // Add the value only if it's neither null nor an empty string
        if (value !== null && value !== "" && value !== undefined) {
          filteredObj[key] = value;
        }
      }
    }
  }
  return filteredObj;
};

function formatNumberToString(value) {
  if (value !== null && value !== undefined && typeof value === "number") {
    return value.toString();
  }
  return value;
}

function getProductDiscounts(discounts) {
  return (discounts || []).reduce((accumulator, discount) => accumulator + discount.amount?.amount, 0) || 0;
}

function getTotalDiscounts(items) {
  return (items || []).reduce((accumulator, item) => accumulator + item.discountAllocations, 0) || 0;
}

function getCommonData(event) {
  return filterNullOrEmpty({
    // shopify_y: event?.clientId,
    // master_id: event?.clientId,
    user_id: init.data?.customer?.id,
    user_data: {
      email: event.data?.checkout?.email || init.data?.customer?.email,
      // orders_count: init.data?.customer?.ordersCount || 0,
      // new_customer: init.data?.customer?.ordersCount > 0 ? 0 : 1,
      phone_number: event?.data?.checkout?.shippingAddress?.phone || init.data?.customer?.phone,
      address: {
        first_name:
          init.data?.customer?.firstName ||
          event.data?.checkout?.shippingAddress?.firstName ||
          event.data?.checkout?.billingAddress?.firstName,
        last_name:
          init.data?.customer?.lastName ||
          event.data?.checkout?.shippingAddress?.lastName ||
          event.data?.checkout?.billingAddress?.lastName,
        street: event?.data?.checkout?.shippingAddress?.address1 || event?.data?.checkout?.billingAddress?.address1,
        city: event.data?.checkout?.shippingAddress?.city || event.data?.checkout?.billingAddress?.city,
        region: event.data?.checkout?.shippingAddress?.province || event.data?.checkout?.billingAddress?.province,
        country:
          event.data?.checkout?.shippingAddress?.countryCode || event.data?.checkout?.billingAddress?.countryCode,
        country_code:
          event.data?.checkout?.shippingAddress?.countryCode || event.data?.checkout?.billingAddress?.countryCode,
        postal_code: event.data?.checkout?.shippingAddress?.zip || event.data?.checkout?.billingAddress?.zip,
        province: event.data?.checkout?.shippingAddress?.province || event.data?.checkout?.billingAddress?.province,
        province_code:
          event.data?.checkout?.shippingAddress?.provinceCode || event.data?.checkout?.billingAddress?.provinceCode,
      },
    },
    page_location: event.context?.document?.location?.href,
    page_referrer: event.context?.document?.referrer,
    page_title: event.context?.document?.title,
    page_path: event.context?.document?.location?.pathname,
  });
}

function createLineItemsData(lineItems) {
  return lineItems.map((item) => {
    const discountTitle = (item?.discountAllocations || [])
      .map((discount) => discount.discountApplication?.title)
      .join(" ");
    const discountPrice = getProductDiscounts(item.discountAllocations) / item.quantity;
    const price = item?.variant?.price?.amount - discountPrice;

    return {
      ...createProductVariantData(item?.variant),
      price: price,
      quantity: item?.quantity,
      discount: discountPrice,
      coupon: discountTitle,
    };
  });
}

function createProductVariantData(productVariant) {
  return {
    item_id: formatNumberToString(productVariant.product?.id),
    item_variant: `${productVariant.product?.title} - ${productVariant.title || "Default Variant"}`,
    item_variant_id: formatNumberToString(productVariant.id),
    item_variant_title: `${productVariant.product?.title} - ${productVariant.title || "Default Variant"}`,
    item_product_id: formatNumberToString(productVariant.product?.id),
    item_product_title: productVariant.product?.title,
    item_name: productVariant.product?.title,
    item_brand: productVariant.product?.vendor,
    item_category: productVariant.product?.type,
    item_sku: productVariant.sku,
    price: productVariant.price?.amount,
    sku: formatNumberToString(productVariant.sku),
  };
}

// User

const userUserAttributes = {
  name: `${init.data?.customer?.firstName ? init.data?.customer?.firstName + " " : ""}${init.data?.customer?.lastName || ""
    }`,
  user_id: init.data?.customer?.id,
  email: init.data?.customer?.email,
  phone_number: init.data?.customer?.phone,
};

// window.civchat = filterNullOrEmpty({
//   apiKey: "s0fsur",
//   state: "hidden",
//   canal: "WEB",
//   name: userUserAttributes.name,
//   user_id: userUserAttributes.user_id,
//   shopify_id: userUserAttributes.user_id,
//   email: userUserAttributes.email,
//   phone_number: userUserAttributes.phone_number,
// });

// let scriptUser = document.createElement("script");
// scriptUser.src = `https://willemse.user.com/widget.js`;
// scriptUser.setAttribute("data-cfasync", "false");
// document.body.appendChild(scriptUser);

// Events
const checkoutEventsMapping = {
  checkout_started: "begin_checkout",
  checkout_contact_info_submitted: "add_contact_info",
  checkout_address_info_submitted: "add_address_info",
  checkout_shipping_info_submitted: "add_shipping_info",
  payment_info_submitted: "add_payment_info",
  checkout_completed: "purchase",
};

const ecommerceEventsMapping = {
  cart_viewed: "view_cart",
  product_added_to_cart: "add_to_cart",
  product_removed_from_cart: "remove_from_cart",
  product_viewed: "view_item",
  collection_viewed: "view_item_list",
};

// User
const userEventsMapping = {
  add_to_cart: "add to cart",
  view_item: "view",
  begin_checkout: "checkout",
  purchase: "purchase",
  // add_contact_info: 'add_contact_info'
};

function userengageReady() {
  return new Promise((resolve) => {
    if (typeof window.userengage === "function") {
      resolve(window.userengage);
      return;
    }

    const checkInterval = setInterval(() => {
      if (typeof window.userengage === "function") {
        clearInterval(checkInterval);
        resolve(window.userengage);
      }
    }, 250);
  });
}

function sendEvent(eventName, payload, destinations = [], toDataLayer = false) {
  if (toDataLayer) {
    if (payload.ecommerce) window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: `dl_${eventName}`,
      ...payload,
    });
  }

  if (destinations.filter((v) => v).length == 0) return;

  // Google
  const googleDestinations = destinations.filter((v) => v && ["G-", "AW-", "MC-"].some((p) => v.startsWith(p)));
  if (googleDestinations.length > 0) {
    const { ecommerce, ...payloadWithoutEcommerce } = payload;
    gtag("event", eventName, {
      send_to: googleDestinations,
      ...payloadWithoutEcommerce,
      ...ecommerce,
    });
  }

  // Bing
  const bingDestination = destinations.find((v) => v && !["G-", "AW-", "MC-"].some((p) => v.startsWith(p)));
  if (bingDestination) {
    window.uetq.push(
      "event",
      eventName,
      filterNullOrEmpty({
        page_path: payload.page_path,
        page_title: payload.page_title,
        page_location: payload.page_location,
        // 'event_category': '',
        // 'event_label': '',
        event_value: payload.ecommerce?.value,
        revenue_value: payload.ecommerce?.value,
        currency: payload.ecommerce?.currency,
        transaction_id: payload.ecommerce?.transaction_id,
      })
    );
  }

  // User
  // const userDestination = destinations.find((v) => v && v === "UE");

  // if (userDestination && Object.keys(userEventsMapping).includes(eventName)) {
  //   const { ecommerce, ...payloadWithoutEcommerce } = payload;

  //   // User mail update
  //   if (userUserAttributes.email !== payloadWithoutEcommerce.user_data?.email) {
  //     userUserAttributes.email = payloadWithoutEcommerce.user_data?.email;
  //     userengageReady().then(() => {
  //       userengage("client.update", {
  //         email: userUserAttributes.email,
  //       });
  //     });
  //   }

  //   // Ecommerce event
  //   ecommerce.items.forEach((item) => {
  //     const userPayload = {
  //       ...item,
  //       product_id: item.item_id,
  //       event_type: userEventsMapping[eventName],
  //     };
  //     userengageReady().then(() => {
  //       userengage("product_event", userPayload);
  //       // console.log(userPayload);
  //     });
  //   });
  // }
}

analytics.subscribe("all_standard_events", (event) => {
  // console.log(event);

  const commonData = getCommonData(event);

  if (event.name === "page_viewed") {
    sendEvent("page_view", commonData, [ids.ga4, ids.mcc?.destination]);

    // When newsletter form is successfully completed
    if (commonData.page_location.includes("customer_posted=true#ContactFooter")) {
      gtag("event", "generate_lead", {
        send_to: [ids.ga4],
        ...getCommonData(event),
        lead_source: "Newsletter - Footer",
      });
    }
  }

  if (Object.keys(ecommerceEventsMapping).includes(event.name)) {
    switch (event.name) {
      case "product_added_to_cart":
        sendEvent(
          ecommerceEventsMapping[event.name],
          {
            ...commonData,
            page_type: "cart",
            ecommerce: {
              currency: event.data?.cartLine?.cost?.totalAmount?.currencyCode,
              value: event.data?.cartLine?.cost?.totalAmount?.amount,
              items: [
                {
                  ...createProductVariantData(event.data?.cartLine?.merchandise),
                  quantity: event.data?.cartLine?.quantity,
                },
              ],
            },
          },
          [ids.ga4, ids.mcc?.destination, ids.adsConversions[event.name], ids.uet, "UE"]
        );
        break;
      case "product_removed_from_cart":
        sendEvent(
          ecommerceEventsMapping[event.name],
          {
            ...commonData,
            page_type: "cart",
            ecommerce: {
              currency: event.data?.cartLine?.cost?.totalAmount?.currencyCode,
              value: event.data?.cartLine?.cost?.totalAmount?.amount,
              items: [
                {
                  ...createProductVariantData(event.data?.cartLine?.merchandise),
                  quantity: event.data?.cartLine?.quantity,
                },
              ],
            },
          },
          [ids.ga4, ids.mcc?.destination]
        );
        break;
      case "cart_viewed":
        sendEvent(
          ecommerceEventsMapping[event.name],
          {
            ...commonData,
            page_type: "cart",
            ecommerce: {
              currency: event.data?.cart?.cost?.totalAmount?.currencyCode,
              value: event.data?.cart?.cost?.totalAmount?.amount,
              items: event.data?.cart?.lines.map((item) => {
                return {
                  ...createProductVariantData(item.merchandise),
                  quantity: item.quantity,
                };
              }),
            },
          },
          [ids.ga4, ids.mcc?.destination]
        );
        break;
      case "product_viewed":
        sendEvent(
          ecommerceEventsMapping[event.name],
          {
            ...commonData,
            page_type: "product",
            ecommerce: {
              currency: event.data?.productVariant?.price?.currencyCode,
              value: event.data?.productVariant?.price?.amount,
              items: [createProductVariantData(event.data?.productVariant)],
            },
          },
          [ids.ga4, ids.mcc?.destination, ids.adsConversions[event.name], ids.uet, "UE"]
        );
        break;
      case "collection_viewed":
        sendEvent(
          ecommerceEventsMapping[event.name],
          {
            ...commonData,
            page_type: "collection",
            ecommerce: {
              currency: event.data?.cart?.cost?.totalAmount?.currencyCode,
              view_item_id: event.data?.collection?.id,
              item_list_name: event.data?.collection?.title,
            },
          },
          [ids.ga4, ids.mcc?.destination]
        );
        break;
    }
  }

  // Checkout Events
  if (Object.keys(checkoutEventsMapping).includes(event.name)) {
    // if (event.name === "checkout_completed") commonData.new_customer = commonData.user_data.orders_count === 0 ? 1 : 0;

    sendEvent(
      checkoutEventsMapping[event.name],
      {
        ...commonData,
        page_type: event.name === "checkout_completed" ? "purchase" : "checkout",
        ecommerce: {
          transaction_id: event.data?.checkout?.order.id,
          currency: event.data?.checkout?.currencyCode,
          value: event.data?.checkout?.totalPrice?.amount,
          coupon: (event.data?.checkout?.discountApplications || []).map((discount) => discount.title).join(" "),
          discount: event.data?.checkout?.discountsAmount?.amount,
          shipping: event.data?.checkout?.shippingLine?.price?.amount,
          tax: event.data?.checkout?.totalTax?.amount,
          payment_type: event.data?.checkout?.transactions?.[0]?.paymentMethod?.type,
          shipping_tier: event?.data?.checkout?.delivery?.selectedDeliveryOptions?.[0]?.title,
          items: createLineItemsData(event.data?.checkout?.lineItems),
        },
      },
      [
        ids.ga4,
        ids.mcc?.destination,
        ids.adsConversions[event.name],
        event.name === "checkout_completed" &&
          event.data?.checkout?.totalPrice?.amount > 0 &&
          init.customerPrivacy.marketingAllowed
          ? ids.adsConversions.checkout_completed_bis
          : undefined,
        ids.uet,
        "UE",
      ]
    );
  }

  // console.log(window.dataLayer);
});

// analytics.subscribe("clicked", (event) => {
//   console.log(event);
// });

analytics.subscribe("form_submitted", (event) => {
  // console.log(event);

  // Login
  if (event.data?.element?.action?.id === "customer_login") {
    gtag("event", "login", {
      send_to: [ids.ga4],
      method: "Shopify",
      ...getCommonData(event),
    });
  }

  if (event.data?.element?.action?.id === "create_customer") {
    gtag("event", "sign_up", {
      send_to: [ids.ga4],
      method: "Shopify",
      ...getCommonData(event),
    });
  }

  // Search bar
  if ((event.data?.element?.action || "").includes("catalog-search-results")) {
    gtag("event", "search", {
      send_to: [ids.ga4, ids.mcc?.destination],
      ...getCommonData(event),
      page_type: "search",
      search_term: event.data?.element?.elements.find((element) => element.type === "search")?.value || "",
    });
  }
});
